export default {"src":"/_next/static/media/favorite.18ce3acf.svg","height":22,"width":25,"blurWidth":0,"blurHeight":0};